module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1211.50fc9bf9.png";